import classNames from "classnames";

interface Props {
	variant?:
		| "body"
		| "button"
		| "title"
		| "subtitle"
		| "statement"
		| "subtle"
		| "caption"
		| "bold"
		| "label"
		| "light"
		| "light-statement"
		| "subcaption";
	children: React.ReactNode;
	transform?: "first-letter";
	className?: string;
	style?: React.CSSProperties;
}

export const Typography = ({
	variant = "body",
	children,
	transform,
	className,
	style,
}: Props) => {
	if (variant === "title") {
		return (
			<h1
				className={classNames("typography", {
					[`typography--${variant}`]: variant,
					[`typography--${transform}`]: transform,
					[className ?? ""]: Boolean(className),
				})}
				style={style}
			>
				{children}
			</h1>
		);
	}

	if (variant === "subtitle") {
		return (
			<h2
				className={classNames("typography", {
					[`typography--${variant}`]: variant,
					[`typography--${transform}`]: transform,
					[className ?? ""]: Boolean(className),
				})}
				style={style}
			>
				{children}
			</h2>
		);
	}

	return (
		<p
			className={classNames("typography", {
				[`typography--${variant}`]: variant,
				[`typography--${transform}`]: transform,
				[className ?? ""]: Boolean(className),
			})}
			style={style}
		>
			{children}
		</p>
	);
};
